<template>
  <router-view/>
</template>

<script>
import store from '@/store'
import {
  CommonStorage,
  getAuthToken,
  getLoginCheckCookie, isInIframe,
  removeAuthData, requestTokenFromParent,
  setFirstLoginCookie,
  setLoginCheckCookie
} from '@/libs/auth-helper'
import { STORAGE_KEY, storageManager } from '@/libs/storage-manager'
import { SIGNIN_LINK, TOKEN_COOKIE } from '@/libs/constants'
import { insertLoginHistory } from '@/api/user'
import { mapMutations } from 'vuex'
import { parseJwt } from '@/libs/utils'
import { applyFreePlan } from '@/api/userPlan'

export default {
  name: 'TheMember',
  methods: {
    ...mapMutations([
      'setIsFirstLogin'
    ])
  },
  async beforeRouteEnter (to, from, next) {
    let authToken = null

    if (isInIframe() && !getAuthToken()) {
      await requestTokenFromParent(TOKEN_COOKIE.name).then(parentToken => {
        const token = JSON.parse(parentToken)
        const now = new Date().getTime()
        if (token.value && token.expires && now < token.expires) {
          CommonStorage.setItem(TOKEN_COOKIE.name, token.value, { expires: token.expires })
          authToken = token.value
        }
      }).catch(err => {
        console.error('requestTokenFromParent : ', err)
      })
    } else {
      authToken = getAuthToken()
    }

    const goSignIn = () => {
      removeAuthData()
      return next(() => {
        window.location.href = SIGNIN_LINK
      })
    }

    if (!authToken) {
      return goSignIn()
    } else {
      const tokenData = parseJwt(authToken)
      let isDemo = false
      if (tokenData && tokenData.identity) {
        if (tokenData.identity.is_demo) {
          isDemo = true
        }
      }

      const expDate = new Date(0)
      expDate.setUTCSeconds(tokenData.exp)

      const loginCheck = getLoginCheckCookie()

      setFirstLoginCookie('N', expDate)

      const freePlan = await applyFreePlan()
      if (freePlan.beusableFirstLogin) {
        setFirstLoginCookie('Y', expDate)
      }

      if (!loginCheck || loginCheck === 'N') {
        const params = {
          serviceType: 'beusable',
          loginFrom: 'beusable'
        }
        await insertLoginHistory(params)
        setLoginCheckCookie('Y', expDate)
      }

      store.dispatch('storeUserData').then(userData => {
        if (!userData) {
          return goSignIn()
        } else {
          storageManager.initUser(userData.userNum)
          const stickyDataId = storageManager.getItem(STORAGE_KEY.stickyDataId)
          let showStickyData = storageManager.getItem(STORAGE_KEY.showStickyData)
          let showNoPvDialog = storageManager.getItem(STORAGE_KEY.showNoPvDialog)

          if (showStickyData === null) {
            showStickyData = true
            storageManager.setItem(STORAGE_KEY.showStickyData, showStickyData)
          }

          if (showNoPvDialog === null) {
            showNoPvDialog = true
            storageManager.setItem(STORAGE_KEY.showNoPvDialog, showNoPvDialog)
          }
          store.commit('setStickyDataId', stickyDataId)
          store.commit('setShowStickyData', showStickyData)
          store.commit('setShowNoPvDialog', showNoPvDialog)
          store.commit('setIsDemo', isDemo)
          return store.dispatch('storePlanData')
        }
      }).then(() => {
        next()
      }).catch(err => {
        console.error(err)
        return goSignIn()
      })
    }
  }
}
</script>

<style>

</style>
